import React from 'react';
import { ITableHeaderProps } from './TableHeader.types';

const TableHeader = ({ children, style, paddingRight, className = '', ...props }: ITableHeaderProps) => {
  return (
    <div style={{ paddingRight, ...style, ...props }} className={className}>
      {children}
    </div>
  );
};

export default TableHeader;
